<template>
    <div>
        <svg id="interfaz" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 104 106">
        <defs>
            <clipPath id="clip-path">
            <circle cx="52" cy="50.05" r="47.57" fill="none"/>
            </clipPath>
        </defs>
            <g class="componente-personaje">
                <g clip-path="url(#clip-path)">
                    <circle class="cls-33" cx="50.19" cy="54.45" r="55.01"/>
                    <image  width="167" height="210" class="imagen-svg"
                            transform="matrix(.77 0 0 .77 -3.72 8.85)"
                            href="../assets/imagenes_compartidas/glosario/icono/slide-34.png"
                    />
                </g>
                <circle cx="52" cy="50.05" r="47.57" stroke="#50bfbf" stroke-miterlimit="10" stroke-width="2" fill="none"/>
                <rect class="cls-5" x="1.93" y="77.64" width="100.15" height="27.1" rx="2.74" fill="#a65682"/>
                <text class="cls-3" transform="translate(28.94 96.68)" font-size="17.67" font-weight="600" fill="#fff">
                    Glosario
                </text>
                <path fill="#03738c" d="M11.35 82.84h15.32v16.69H11.35z"/>
                <path class="cls-3" d="M12.04 82.3h13.91v16.69H12.04z"/>
                <path fill="#50bfbf" d="M11.35 81.61h13.91V98.3H11.35z"/>
                <path fill="#f23d5e" d="M13.11 98.67h1.41v2.11h-1.41z"/>
                <path class="cls-11" d="M12.93 92.94l1.84-5.63h1.17l1.83 5.63h-1.05l-.44-1.52h-1.89L14 92.94zm1.89-3l-.2.69h1.44l-.2-.69c-.09-.3-.18-.61-.26-.92s-.17-.63-.25-.94l-.24.94c-.11.32-.2.63-.29.98zM17.61 91.13v-.72h2.05v.72zM19.69 92.94v-.6l2.72-4.18h-2.48v-.85h3.71v.6l-2.72 4.19h2.74v.84z"/>
            </g>
        </svg>
    </div>
</template>
<script>
export default {
    data(){
        return{
            // modulo:'12',
            // urlImg:''
        }
    },
}
</script>
<style lang="scss" scoped>
@import '../sass/globals';

.cls-3{fill:#fff; font-family: FontBase-Regular;}
.cls-6{fill:#03738c}
.cls-5{fill:#a65682;}

.cls-33{fill:#ff9676}
.cls-3{fill:#fff}
.cls-11{fill:#0e292d}
.componente-personaje:hover  > .cls-5{
    fill: $color-complement-two;
}
.componente-personaje:hover  > .cls-3{
    fill:#03738c;
}
.imagen-svg, image{
    height: 162px;
    width: auto;
}
</style>